import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/style.css";
import UserIcon from "../../assets/angket/user.png";

export default function Header() {
  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const menuRef = useRef(null);

  const studentProfile = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("student_profile") || "{}");
    } catch {
      return {};
    }
  }, []);

  const student = useMemo(() => {
    return {
      name: studentProfile?.nama_siswa || "-",
    };
  }, [studentProfile]);

  // detect mobile
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 640px)");
    const onChange = (e) => setIsMobile(e.matches);

    setIsMobile(mq.matches);
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  // close dropdown when click outside (only relevant on desktop/tablet)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target)) setIsMenuOpen(false);
    };

    const handleEsc = (e) => {
      if (e.key === "Escape") setIsMenuOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  const handleLogout = () => {
    setIsMenuOpen(false);
    navigate("/");
  };

  return (
    <div>
      <header style={styles.topbar}>
        <div style={styles.brandWrap}>
          <div style={styles.brandIcon}>🎓</div>
          <span style={styles.brandText}>SIMAM</span>
        </div>

        <div style={styles.topbarRight}>
          {/* MODE HP: hanya tombol Keluar */}
          {isMobile ? (
            <button type="button" style={styles.logoutBtn} onClick={handleLogout}>
              ⤴ Keluar
            </button>
          ) : (
            /* MODE DESKTOP/TABLET: tombol nama siswa + dropdown */
            <div style={styles.menuWrap} ref={menuRef}>
              <button
                type="button"
                style={{
                  ...styles.userBtn,
                  ...(isMenuOpen ? styles.userBtnActive : {}),
                }}
                onClick={() => setIsMenuOpen((v) => !v)}
                aria-haspopup="menu"
                aria-expanded={isMenuOpen}
              >
                <img src={UserIcon} alt="User" style={styles.userImg} />
                <div style={{ textAlign: "left" }}>
                  <div style={styles.userName}>{student.name}</div>
                  <div style={styles.userRole}>Siswa</div>
                </div>
                <span style={styles.caret}>{isMenuOpen ? "▲" : "▼"}</span>
              </button>

              {isMenuOpen && (
                <div style={styles.dropdown} role="menu">
                  <button
                    type="button"
                    style={styles.dropdownItemDanger}
                    onClick={handleLogout}
                    role="menuitem"
                  >
                    ⤴ Keluar
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </header>
    </div>
  );
}

const styles = {
  topbar: {
    height: 74,
    background: "#FFFFFF",
    borderBottom: "1px solid #E5E7EB",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 22px",
    position: "sticky",
    top: 0,
    zIndex: 20,
  },
  brandWrap: { display: "flex", alignItems: "center", gap: 10 },
  brandIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    background: "#EEF2FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  brandText: { fontSize: 20, fontWeight: 700, color: "#1F2937" },
  topbarRight: { display: "flex", alignItems: "center", gap: 12 },

  // HP logout button
  logoutBtn: {
    border: "1px solid #ff5a5a",
    background: "#ffffff",
    color: "#EF4444",
    padding: "10px 12px",
    borderRadius: 12,
    cursor: "pointer",
    fontWeight: 800,
    fontSize: 13
  },

  menuWrap: { position: "relative" },
  userBtn: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 10px",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    background: "#FFFFFF",
    cursor: "pointer",
  },
  userBtnActive: {
    border: "1px solid #CBD5E1",
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.10)",
  },
  userImg: {
    width: 30,
    height: 30,
    // borderRadius: "50%",
    objectFit: "cover",
    // background: "#F3F4F6",
  },
  caret: { marginLeft: 6, fontSize: 10, color: "#6B7280", lineHeight: 1 },
  userName: { fontSize: 13, fontWeight: 700, lineHeight: 1.2, color: "#111827" },
  userRole: { fontSize: 12, color: "#6B7280" },

  dropdown: {
    position: "absolute",
    top: "calc(100% + 8px)",
    right: 0,
    minWidth: 180,
    background: "#FFFFFF",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.12)",
    padding: 6,
    zIndex: 50,
  },
  dropdownItemDanger: {
    width: "100%",
    textAlign: "left",
    border: "none",
    background: "transparent",
    padding: "10px 10px",
    borderRadius: 10,
    cursor: "pointer",
    color: "#EF4444",
    fontWeight: 700,
  },
};